<template>
  <section class="quick-filter-panel">
    <SpotlightSearchFilterHeader :title="$t('Ownership')" />
    <SpotlightSearchFilterItem
      :title="$t('Assigned to me')"
      :default-value="ownershipDefaultValue"
      :filter="SpotlightSearchFilter.ESTATE_ASSIGNED_TO_ME"
      @on-filter="onFilter"
      :data-e2e="SpotlightCypressAttribute.buttons.ESTATE_ASSIGNED_TO_ME"
    />
    <SpotlightSearchFilterHeader :title="$t('Inactive')" />
    <SpotlightSearchFilterItem
      :title="$t('Show closed')"
      :default-value="showClosedDefaultValue"
      :filter="SpotlightSearchFilter.SHOW_CLOSED"
      @on-filter="onFilter"
    />
    <SpotlightSearchFilterItem
      :title="$t('Show deleted')"
      :default-value="showDeletedDefaultValue"
      :filter="SpotlightSearchFilter.SHOW_DELETED"
      @on-filter="onFilter"
    />
    <!--    <SpotlightSearchFilterHeader :title="$t('Created date')" />-->
    <!--    <SpotlightSearchFilterItem :title="$t('Today')" :value="SpotlightSearchFilter.CREATED_TODAY" />-->
    <!--    <SpotlightSearchFilterItem-->
    <!--      :title="$t('In the last 7 days')"-->
    <!--      :value="SpotlightSearchFilter.CREATED_IN_LAST_7_DAYS"-->
    <!--    />-->
  </section>
</template>

<script>
import SpotlightSearchFilterHeader from '@/modules/spotlight/components/functional/SpotlightSearchFilterHeader.vue';
import SpotlightSearchFilterItem from '@/modules/spotlight/components/stateful/SpotlightSearchFilterItem.vue';
import { SpotlightSearchFilter } from '@/modules/spotlight/constants/SpotlightSearchFilter';
import { SpotlightSearchFilterValues } from '@/modules/spotlight/constants/SpotlightSearchFilterValues';
import { HasPermissionMixin } from '@/modules/core/app/mixins/HasPermissionMixin';
import { SpotlightCypressAttribute } from '@/modules/spotlight/constants/SpotlightCypressAttribute';
import { HasAuthUserMixin } from '@/modules/core/app/mixins/HasAuthUserMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightSearchFilters',
  emits: ['on-filter'],
  mixins: [HasPermissionMixin, HasAuthUserMixin],
  components: { SpotlightSearchFilterItem, SpotlightSearchFilterHeader },
  static: { SpotlightSearchFilter, SpotlightCypressAttribute },
  data() {
    return {
      values: SpotlightSearchFilterValues
    };
  },
  computed: {
    ownershipDefaultValue() {
      return !this.authUser.isAdminEstateProfessional;
    },
    showClosedDefaultValue() {
      return SpotlightSearchFilterValues.show_closed;
    },
    showDeletedDefaultValue() {
      return SpotlightSearchFilterValues.show_deleted;
    }
  },
  methods: {
    onFilter(key, value) {
      this.values[key] = value;
      this.$emit('on-filter', this.values);
    }
  }
};
</script>

<style scoped>
.quick-filter-panel {
  width: var(--ce-200px);
  height: 100%;
  position: relative;
  border-left: var(--ce-1px) solid var(--ce-border);
  padding: var(--ce-20px) 0 var(--ce-20px) var(--ce-25px);
}
</style>
